import { render, staticRenderFns } from "./SupplierBuyDocs.vue?vue&type=template&id=3782ee58&"
import script from "./SupplierBuyDocs.vue?vue&type=script&lang=js&"
export * from "./SupplierBuyDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports